__turbopack_context__.v({
  "h6": "o-info-dialog-module-scss-module__MOH19G__h6",
  "header": "o-info-dialog-module-scss-module__MOH19G__header",
  "headline": "o-info-dialog-module-scss-module__MOH19G__headline",
  "placeholder": "o-info-dialog-module-scss-module__MOH19G__placeholder",
  "text": "o-info-dialog-module-scss-module__MOH19G__text",
});
